import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  usePagination,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  DialogActions,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import { styled, alpha } from "@mui/material/styles";
import cssVariables from "../../../../theme/cssVariables";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import { getGroupLibrary, getLibraryList } from "../../../../actions/corporateGoal";
import myGoalService from "../../../../services/mygoal.service";

import { ReactComponent as LibraryBanner } from "../../../../icons/library-banner.svg";
import { ReactComponent as BackIcon } from "../../../../icons/arrow-left.svg";
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import CloseIcon from "../../../../assets/images/plus-circle-fill.svg";
import { ReactComponent as ArrowUp } from "../../../../icons/arrow-up.svg";
import { ReactComponent as ArrowRight } from "../../../../icons/arrow-right.svg";

// import axios from "axios";
function CustomPagination(props) {
  const useStyles = makeStyles({
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },

  });
  const classes = useStyles();
  const { t } = useTranslation();
  const List = styled("ul")({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
  });
  const { items } = usePagination({
    count: props.count,
    showFirstButton: true,
    showLastButton: true,
  });
  return (
    <nav>
      <List>
        {items.length > 0 ? (
          items.map(({ page, type, selected, ...item }, index) => {
            let children = null;
            selected = type === "page" && page === props.selected ? props.selected : selected
            if (type === "start-ellipsis" || type === "end-ellipsis") {
              children = "…";
            } else if (type === "page") {
              children = (
                <Button
                  {...item}
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {page}
                </Button>
              );
            } else if (type === "first" || type === "last") {
              children = (
                <Button
                  {...item}
                  disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                </Button>
              );
            } else {
              children = (
                <Button
                  {...item}
                  disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                  size="small"
                  type="button"
                  variant="outlined"
                  sx={{ textTransform: "none" }}
                  classes={{
                    root: classes.paginationRoot,
                  }}
                >
                  {type === "previous"
                    ? t("label.previous")
                    : type === "next"
                      ? t("label.next")
                      : ""}
                </Button>
              );
            }
            return <li key={index}>{children}</li>;
          })

        ) : (
          <></>
        )}
        {props.setCurrentPage(items)}
      </List>
    </nav>
  );
}
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '15ch',
    },
  },
}));
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#343A40",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#343A40",
    color: "#FFFFFF",
    padding: "11px 15px",
  },
}));
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 1),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 1),
  },
  marginRight: theme.spacing(2),
  marginLeft: '100px',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(0),
    width: 'auto',
  },
  border: '1px solid #E5E5E5'
}));
const CreateFromLibraryCorporateGoal = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const _ = require("lodash");
  const navigate = useNavigate();
  const { state } = useLocation();

  const [showSelectPopup, setShowSelectPopup] = React.useState(false);
  const [showAlignment, setShowAlignment] = React.useState(false);
  const [checked, setChecked] = React.useState({});
  const [groupIn, setGroupIn] = React.useState([]);
  const [subMenu, openSubMenu] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);
  const [totalItem, setTotalItem] = React.useState(1);
  const [goalGroupList, setGoalGroupList] = React.useState([]);
  const [goalLibraryList, setGoalLibraryList] = React.useState([]);
  const [librarySearch, setLibrarySearch] = React.useState();
  const [libraryDetail, setLibraryDetail] = React.useState({})
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };


  const chooseLibrary = (val) => {
    val.librarySerial = val.serial;
    // val.serial = state.serial;
    setLibraryDetail(val)
    setShowSelectPopup(true);
  }

  const handleCloseDialog = () => {
    setShowSelectPopup(false);
  };

  const goBack = () => {
    back('/manage-corporate-goal')
  }

  const back = (val) => {
    if (showAlignment) {
      setShowAlignment(false);
    } else
      goto(val)
  }
  const goto = (path, data) => {
    if (data) {
      navigate("/admin" + path, { replace: false, state: data })
    } else {
      navigate("/admin" + path, { replace: false });
    }
  }
  const useGoal = () => {
    var combineState = Object.assign(state, libraryDetail);
    goto('/manage-corporate-goal/create/1', combineState)
  }

  const handleChange1 = (event, id, idx) => {
    var stateCheck = { ...checked }
    let getGroup = [];
    var uniqueList = array => [...new Set(array)];

    if (goalGroupList[idx].children != null && goalGroupList[idx].children.length > 0) {
      goalGroupList[idx].children.map((data) => {
        getGroup.push(data.id)
      })
    } else {
      getGroup.push(id)
    }
    if (event.target.checked == true) {
      getGroup = [...groupIn, ...getGroup]
      setGroupIn(uniqueList(getGroup))
    } else {
      getGroup.map((group) => {
        var index = groupIn.indexOf(group);
        if (index !== -1) {
          groupIn.splice(index, 1);
        }
      })
      getGroup = groupIn;
    }
    if (stateCheck[id] != null && stateCheck[id].length > 0) {
      stateCheck[id] = stateCheck[id].map(() => { return event.target.checked });
    } else {
      stateCheck[id] = [event.target.checked]
    }
    setChecked(stateCheck);
    getApiLibraryList(librarySearch, uniqueList(getGroup))
  };

  const handleChange2 = (event, list, idx) => {
    const stateCheck = { ...checked }
    let getGroup = [];

    getGroup.push(list.children[idx].id)

    if (event.target.checked == true) {
      getGroup = [...groupIn, ...getGroup]
      setGroupIn(getGroup)
    } else {
      getGroup.map((group) => {
        var index = groupIn.indexOf(group);
        if (index !== -1) {
          groupIn.splice(index, 1);
        }
      })
      getGroup = groupIn
    }

    stateCheck[list.id][idx] = event.target.checked;
    setChecked(stateCheck);
    getApiLibraryList(librarySearch, getGroup)
  };

  const openMenu = (val) => {
    if (val == subMenu) {
      openSubMenu(0);
    } else {
      openSubMenu(val);
    }
  };

  const handleSetCurrentPage = (value) => {
    const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
    if (getSelectedPage.length > 0 && getSelectedPage[0].page != currentPage) {
      setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
      getApiLibraryList(librarySearch, groupIn)
    }
  };

  const someCheck = (id) => {
    if (checked[id]) {
      if (checked[id].every((data) => data == true)) {
        return false;
      } else {
        return checked[id].some((data) => data == true)
      }
    } else {
      return false
    }
  }

  const everyCheck = (id) => {
    if (checked[id]) {
      return checked[id].every((data) => data == true)
    } else {
      return false
    }
  }

  const searchLibraryList = (e) => {
    if (e.target.value == null) {
      setLibrarySearch(e.target.value)

    }
    setLibrarySearch(e.target.value)
    getApiLibraryList(e.target.value, groupIn)
  }

  const searchGoalGroup = (e) => {
    getApiGoalGroup(e.target.value)
  }

  useEffect(() => {
    let resultGroupSelected = []
    dispatch(getGroupLibrary(state?.cycleSerial))
      .then(resp => {
        setGoalGroupList(resp.data.goalGroups)
        resp.data.goalGroups.map((item) => {
          item?.children?.forEach(child => {
            resultGroupSelected.push(child.id)
          })
          if (item.children != null) {
            var id = item.id;
            Object.assign(checked, { [id]: item.children.map(v => { return true }) })
          }
          setChecked(checked)
        })
        setGroupIn(resultGroupSelected)
        dispatch(getLibraryList(state?.cycleSerial, 12, currentPage, undefined, resultGroupSelected))
          .then(resp => {
            setTotalPage(resp.data.totalPage);
            setTotalItem(resp.data.totalItem);
            setGoalLibraryList(resp.data.goalLibraryList);
          })
      })
  }, []);

  function getApiLibraryList(search, _groupIn) {
    dispatch(getLibraryList(state?.cycleSerial, 12, currentPage, search != null ? search : librarySearch, _groupIn != null ? _groupIn : groupIn))
      .then((resp) => {
        setTotalPage(resp.data.totalPage);
        setTotalItem(resp.data.totalItem);
        setGoalLibraryList(resp.data.goalLibraryList);
      })
  }

  function getApiGoalGroup(search) {
    myGoalService.getGroup(search)
      .then((resp) => {
        setGoalGroupList(resp.data.goalGroups);
        if (checked.length == 0) {
          resp.data.goalGroups.map((item) => {
            if (item.children != null) {
              var id = item.id;
              Object.assign(checked, { [id]: item.children.map(v => { return false }) })
            }
            setChecked(checked);
          })
        }
      })
  }

  const childrenList = (list) => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3, transition: "1s ease" }}>
        {list.children.map((item, idx) => {
          return (
            <FormControlLabel
              label={<Typography color="#404349">{item.name}</Typography>}
              control={<Checkbox checked={checked[list.id][idx]} onChange={(val) => { handleChange2(val, list, idx) }} />}
            />
          )
        })}
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title>Create Goal | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => navigate("/kpi/home")}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/manage-corporate-goal')}>
                {` ${t('corporateGoal.label.title')}`}
              </span> /
              <span style={styles.end} >
                {` ${t('corporateGoal.label.create')}`}
              </span>
            </Typography>
          </Grid>
          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography fontSize={36} lineHeight="39.6px" fontWeight="500" color="#404349">
                {t('corporateGoal.label.goalItem')}
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16} color="#404349">
                {t('corporateGoal.label.goalItemSub')}
              </Typography>
            </Grid>
            <Grid item md={12}>
              {/* <LibraryBanner /> */}
              {
                i18n.language === "th-TH" ?
                  <img src={require('../../../../icons/library-banner-th.svg').default} alt="Banner" />
                  : i18n.language === "en-US" ?
                    <img src={require('../../../../icons/library-banner.svg').default} alt="Banner" />
                    : null
              }
            </Grid>
          </Grid>
          <Grid container direction="row" mt={4}>
            <Grid item md={2}>
              <Grid item md={12}>
                <Typography variant="label" fontSize="16px" fontWeight="500">
                  {t('corporateGoal.label.goalGroup')}
                </Typography>
              </Grid>
              <Grid container direction="row" mt={1}>
                <Grid item md={12}>
                  <Search>
                    <SearchIconWrapper>
                      <SearchIcon style={{ color: '#C4C4C4' }} />
                    </SearchIconWrapper>
                    <StyledInputBase
                      placeholder={t("label.search")}
                      inputProps={{ 'aria-label': 'search' }}
                      onChange={searchGoalGroup}
                    />
                  </Search>
                </Grid>
              </Grid>
              {goalGroupList.map((list, idx) => {
                return (
                  <Box>
                    <Grid container direction="row" alignItems="center" mt={1} lg={12}>
                      <Grid item lg={12}>
                        <Grid container direction="row" lg={12}>
                          <Grid item lg={11}>
                            <FormControlLabel
                              label={<Typography color="#404349">{list.name}</Typography>}
                              control={
                                <Checkbox
                                  checked={everyCheck(list.id)}
                                  indeterminate={someCheck(list.id)}
                                  onChange={(e) => { handleChange1(e, list.id, idx) }}
                                />
                              }
                            />
                          </Grid>
                          <Grid item lg={1} style={{ alignSelf: 'center' }}>
                            {(list.children != null)
                              ? subMenu == idx
                                ?
                                <ArrowUp style={{ cursor: "pointer" }} onClick={() => openMenu(idx)} />
                                :
                                <ArrowRight style={{ cursor: "pointer" }} onClick={() => openMenu(idx)} />
                              :
                              <Box></Box>
                            }
                          </Grid>
                        </Grid>
                        {(subMenu == idx && list.children != null && Object.keys(checked).length > 0) &&
                          childrenList(list)
                        }
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                  </Box>
                )
              })}
            </Grid>
            <Grid item md={10} pl={2}>
              <Box style={{ border: '0px solid #dadada', borderLeftWidth: '1px' }}>
                <Grid pl={3} pb={3} container>
                  <Grid item md={8}>
                    <Typography fontSize={22} fontWeight="600" color="#404349">
                      {t('corporateGoal.label.goalItemList')}
                    </Typography>
                    <Typography fontSize={16} variant="label">
                      {t("corporateGoal.label.showing")} {totalItem} {t("corporateGoal.label.items")}
                    </Typography>
                  </Grid>
                  <Grid item md={4}>
                    <Search>
                      <SearchIconWrapper>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder={t("label.search")}
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={searchLibraryList}
                      />
                    </Search>
                  </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch">
                  {goalLibraryList.map((item) => {
                    return (
                      <Grid lg={4} xs={12} pl={3} pb={3} item>
                        <Card style={{ cursor: 'pointer', height: '100%', border: '0px', borderRadius: '10px', boxShadow: '0 0 0 0 rgb(0 0 0 / 10%), 0px 4px 10px -1px rgb(0 0 0 / 10%)' }} onClick={() => { chooseLibrary(item) }}>
                          <CardContent>
                            <Grid container>
                              <Grid item>
                                <Box style={{ backgroundColor: "#4085C91A", borderRadius: 20, paddingLeft: 15, paddingTop: 8, paddingBottom: 8, paddingRight: 15, textAlign: 'center' }}>
                                  <Typography color="#4085C9">
                                    {item?.category?.name}
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                            <Grid item lg={12} xs={12} container textAlign="left">
                              <Grid item lg={12} mt={'10px'}>
                                <BootstrapTooltip
                                  placement="right"
                                  arrow
                                  title={item.name}
                                  style={{ marginRight: '5px' }}
                                >
                                  <Typography fontSize={18} lineHeight="21px" fontWeight="600" color="#404349" sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}>
                                    {item.name}
                                  </Typography>
                                </BootstrapTooltip>
                              </Grid>
                              <Grid item lg={12} mt={'10px'}>
                                <BootstrapTooltip
                                  placement="right"
                                  arrow
                                  title={item.name}
                                  style={{ marginRight: '5px' }}
                                >
                                  <Typography fontSize={14} lineHeight="21px" variant="label" sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}>
                                    {item.description}
                                  </Typography>
                                </BootstrapTooltip>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    )
                  })}
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Grid container direction="row" style={{ marginTop: '85px' }}>
            <Grid container xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => goBack()}>
              <Grid item mt={0.5}>
                <BackIcon />
              </Grid>
              <Grid item ml={1}>
                <Typography color="#404349">
                  {t("label.back")}
                </Typography>
              </Grid>
            </Grid>
            <Grid lg={7} xs={12} item textAlign="center">
            </Grid>
            <Grid container lg={4} xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'right', cursor: 'pointer' }}>
              <CustomPagination
                setCurrentPage={handleSetCurrentPage}
                selected={currentPage}
                count={totalPage}
              ></CustomPagination>
            </Grid>
          </Grid>
          <Dialog onBackdropClick={() => { return false }} open={showSelectPopup} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '10px', paddingTop: '0px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row">
                <Grid item>
                  <Typography fontSize={24} fontWeight="600" style={{ paddingBottom: '10px' }}>
                    {t('mygoal.label.goalDetail')}
                  </Typography>
                </Grid>
                <Grid item>
                  <Box sx={{ position: "absolute", right: 0, margin: "25px 30px 0  0", top: 0 }} className="clickable" onClick={handleCloseDialog}><img src={CloseIcon} alt="browser" /></Box>
                </Grid>
              </Grid>
              <Divider />
              <Grid container>
                <Grid container>
                  <Grid item mt={3}>
                    <Box style={{ backgroundColor: "#4085C91A", borderRadius: 20, padding: 5, paddingLeft: 9, paddingRight: 9, textAlign: 'center' }}>
                      <Typography style={{ color: '#4085C9' }}>
                        {libraryDetail?.category?.name}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Grid item lg={12} mt={2}>
                  <Typography fontSize={24} style={{ color: '#404349', fontWeight: '600' }}>
                    {libraryDetail?.name}
                  </Typography>
                </Grid>
                <Grid item lg={12} mt={1}>
                  <Typography fontSize={14} style={{ color: '#A3A3A3' }}>
                    {libraryDetail?.description}
                  </Typography>
                </Grid>
                <Grid item lg={3} mt={2}>
                  <Typography fontSize={16} style={{ color: '#404349' }}>
                    {t('mygoal.label.goalMetric')}
                  </Typography>
                </Grid>
                <Grid item lg={9} mt={2}>
                  <Typography fontSize={16} style={{ color: '#A3A3A3' }}>
                    {libraryDetail?.metric?.description}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Box classes="mt-3">
                <Button onClick={useGoal} color="primary" variant="contained" style={{ paddingLeft: '48px', paddingRight: '48px', textTransform: 'none' }}>
                  {t('mygoal.label.useGoal')}
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    </>
  );
};
export default CreateFromLibraryCorporateGoal;
